module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UXk6e9/images/9781439661529.jpg?1684514751584",
      "alt": "This image is the cover for the book Willamette Valley Wineries, Images of Modern America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Willamette Valley Wineries, Images of Modern America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Despite its short, 50-year history, Oregon's Willamette Valley was named Wine Region of the Year in 2016 by Wine Enthusiast, besting Champagne, France; Crete, Greece; and Sonoma, California. Credit for the award can be traced to the pioneer winemakers, a small group of dreamers who--through grit and determination--succeeded in growing grapes where it was considered impossible. Wine has been made in Oregon since the mid-1800s, but it was not until 1965 that winemaking began in earnest in the region. That year, David and Diana Lett planted 3,000 pinot noir vines on a carefully selected south-facing slope. Others joined the adventure, and through collaboration and a passion for making the best wine possible, the Willamette Valley's wine industry was born. This book presents a history of the challenges, hardships, and ultimate success of Willamette Valley wineries.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Barbara Smith Randall\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Author Barbara Smith Randall shares this history through photographs and stories from winemakers and their families, as well as the resources at Linfield College's Oregon Wine History Archives in McMinnville, Oregon. She lives in the heart of the Willamette Valley American Viticultural Area.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0